import withTranslations from './withTranslations';
import withStore from './withStore';


export default {
  withTranslations,
  withStore
}



// WEBPACK FOOTER //
// ./common/hocs/index.js